import { IFlowEventData } from 'types/analytics';

export const CHANGE_EMAIL_LINK = 'https://support.ubi.com/en-GB/Faqs/000026736';
export const STEP_EMAIL_VERIFICATION = 'STEP_EMAIL_VERIFICATION';

// Actions
export const RESET_EMAIL_VERIFICATION = 'RESET_EMAIL_VERIFICATION' as const;
export const SET_EMAIL_VERIFICATION_STATUS = 'SET_EMAIL_VERIFICATION_STATUS' as const;
export const SET_EMAIL_VERIFICATION = 'SET_EMAIL_VERIFICATION' as const;

// Status states
export enum EMAIL_VERIFICATION {
    NOT_COMPLETED = 'NOT_COMPLETED',
    SENT = 'SENT',
    SENDING = 'SENDING',
    COMPLETED = 'COMPLETED',
    NOT_VERIFIED = 'NOT_VERIFIED'
}

export const TEXT_KEYS = {
    EMAIL_VERIFICATION_TEXTS: {
        warning: 'email-verification__verification-text-warning',
        linking: 'email-verification__verification-text-linking',
        prompting: 'email-verification__verification-text-prompting',
        sending: 'email-verification__verification-text-sending',
        sent: 'email-verification__verification-text-sent',
    },
    EMAIL_VERIFICATION_CANCEL_BTN: 'email-verification__cancel-button-text',
    EMAIL_VERIFICATION_OK_BTN_VERIFY: 'email-verification__ok-button-verify',
    EMAIL_VERIFICATION_OK_BTN_CONTINUE: 'email-verification__ok-button-continue',
    EMAIL_VERIFICATION_EMAIL_CHANGE_SUGGESTION: 'email-verification__email-change-suggestion',
    EMAIL_VERIFICATION_ERROR: 'email-verification__error',
};

export const EMAIL_VERIFICATION_FLOW_STEP: Pick<IFlowEventData, 'flowStep' | 'flowStepDetails'> = {
    flowStep: 'email verification',
    flowStepDetails: 'prompting'
};

export const EMAIL_VERIFICATION_DETAILS_SENDING: Pick<IFlowEventData, 'flowStepDetails'> = {
    flowStepDetails: 'sending'
};

export const EMAIL_VERIFICATION_DETAILS_SENT: Pick<IFlowEventData, 'flowStepDetails'> = {
    flowStepDetails: 'sent'
};

export enum EMAIL_VERIFICATION_ACTIONS {
    PROMPTING = 'email verification : prompting',
    VERIFY = 'verify my email',
    SKIP = 'skip email verification',
    USE_ANOTHER = 'use another email',
    SEND_ANOTHER = 'email verification : send another email',
    SENDING = 'email verification : sending',
    CHANGE = 'email verification : change email',
    SENT = 'email verification : sent',
    CONTINUE = 'email verification : continue',

}
